import React from 'react';
import { IConfigComponent } from '@ts/ui-models';
import GlobalDataGrid, { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';

export const defaultConfigComponent: IConfigComponent = generateConfigComponent('entity');

interface IEntityProps {
  inheritedProps?: any;
}

const Entities = (props: IEntityProps) => {
  return <GlobalDataGrid configComponent={defaultConfigComponent} inheritedProps={props.inheritedProps} />;
};

export default Entities;
